import { i18n } from '@fs/zion-locale'

export default {
  advancedSearch: () => i18n.t('searchForm.advancedSearch', 'Advanced Search'),
  doYouWantToTryJiapuSearch: () =>
    i18n.t('jiapuExperienceDialog.subTitle', 'Do you want to try the Chinese Jiapu Search?'),
  doYouWantToTryJokboSearch: () =>
    i18n.t('jokboExperienceDialog.subTitle', 'Do you want to try the Korean Jokbo Search?'),
  doYouWantToTryKeizuSearch: () =>
    i18n.t('keizuExperienceDialog.subTitle', 'Do you want to try the Japanese Keizu Search?'),
  fewerOptions: () => i18n.t('searchForm.fewerOptions', 'Fewer Options'),
  jiapuDescription: () =>
    i18n.t(
      'jiapuExperienceDialog.description',
      'A jiapu is a multi-generational family record maintained by a Chinese clan.'
    ),
  jiapuSearchTitle: () => i18n.t('jiapuExperienceDialog.title', 'Jiapu Search'),
  jokboDescription: () =>
    i18n.t(
      'jokboExperienceDialog.description',
      'A jokbo is a multi-generational family record maintained by a Korean clan.'
    ),
  jokboSearchTitle: () => i18n.t('jokboExperienceDialog.title', 'Jokbo Search'),
  keizuDescription: () =>
    i18n.t(
      'keizuExperienceDialog.description',
      'A Keizu is a multi-generational family record maintained by a Japanese clan.'
    ),
  keizuSearchTitle: () => i18n.t('keizuExperienceDialog.title', 'Keizu Search'),
  learnMore: () => i18n.t('searchForm.learnMore', 'Learn More'),
  moreOptions: () => i18n.t('searchForm.moreOptions', 'More Options'),
  search: () => i18n.t('searchForm.search', 'Search'),
}
